import Image from 'next/image';
import Slider from 'react-slick';
import styled, { css } from 'styled-components';
import React, { useState, useEffect, useRef } from 'react';

import useDevice from '@hooks/useDevice';
import { device } from '@styles/mediaQuery';
import { About } from '@shared/constants/content';
import { ArticleHeader, ArticleDescription } from '@components/atoms';

type SliderRef = Slider | null;
type PhotoSliderProps = {
  content: About[];
};

function PhotoSlider({ content }: PhotoSliderProps) {
  const { isMobile } = useDevice();

  const [nav1, setNav1] = useState<SliderRef>(null);
  const [nav2, setNav2] = useState<SliderRef>(null);

  const sliderRef1 = useRef<SliderRef>(null);
  const sliderRef2 = useRef<SliderRef>(null);

  const settings = {
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    setNav1(sliderRef1.current);
    setNav2(sliderRef2.current);
  }, []);
  return (
    <div className="slider-container">
      <IconHolder>
        <StyledIcon
          width={60}
          height={60}
          priority
          alt="clean-eco-icon"
          src="/icons/clean-eco.svg"
        />
      </IconHolder>

      <Slider
        asNavFor={nav2 || undefined}
        ref={(slider) => {
          sliderRef1.current = slider;
        }}
        {...settings}
      >
        {content.map(({ title, picture }) => {
          return (
            <StyledArticle key={title}>
              <ArticleHeader title={title} align="center" margin="20px" />

              <ImageWrapper>
                <Image fill alt={title} src={picture} quality={80} priority />
              </ImageWrapper>
            </StyledArticle>
          );
        })}
      </Slider>

      <Slider
        asNavFor={nav1 || undefined}
        ref={(slider) => {
          sliderRef2.current = slider;
        }}
        slidesToShow={1}
        arrows={false}
      >
        {content.map(({ shortDescription, fullDescription }) => {
          return (
            <DescriptionWrapper key={shortDescription}>
              {isMobile ? (
                <ArticleDescription description={shortDescription} />
              ) : (
                <ArticleDescription description={fullDescription} />
              )}
            </DescriptionWrapper>
          );
        })}
      </Slider>
    </div>
  );
}

const StyledArticle = styled.article`
  width: 100%;

  position: relative;
`;

const ImageWrapper = styled.article`
  width: 100%;
  height: 0;
  position: relative;
  padding-bottom: 56.25%;
  border-radius: 16px;
  overflow: hidden;
`;

const DescriptionWrapper = styled.div`
  margin-top: 25px;
`;

const StyledIcon = styled(Image)`
  position: absolute;
  z-index: 1;
  right: -20px;
  top: 40px;

  ${device.tablet(css`
    top: 60px;
  `)}
`;

const IconHolder = styled.div`
  position: relative;
  width: 100%;
  height: 0;
`;

export default PhotoSlider;
